module.exports = __webpack_public_path__ + "img/defaultProfilePicture.1c2739ab.jpg";